/**
 * BirthdayBackground - Responsive birthday-themed decoration overlay
 *
 * Uses CSS background-image with media queries for optimal image selection:
 * - Desktop (landscape): IMG_0641.PNG
 * - Mobile (portrait): IMG_0642.PNG
 *
 * Images are transparent PNGs with white chalk-line art (cake, fireworks)
 * that overlay on the existing lavender background.
 */

interface BirthdayBackgroundProps {
  children: React.ReactNode
  className?: string
  enabled?: boolean
}

export function BirthdayBackground({
  children,
  className = '',
  enabled = true
}: BirthdayBackgroundProps) {
  if (!enabled) {
    return <>{children}</>
  }

  return (
    <div className={`relative ${className}`}>
      {/* Background decoration layer */}
      <div
        className="absolute inset-0 birthday-bg pointer-events-none z-10"
        aria-hidden="true"
      />
      {/* Content layer - above background */}
      <div className="relative z-20">
        {children}
      </div>
    </div>
  )
}
